// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CHir5","rootNoMargin":"styles_rootNoMargin__2Ez6N"};